// --- INTENTION_MODE (macro) ---
// Had a Dart counterpart (intention_mode.dart) in the v0.8 app/ tree; that tree
// was retired and the v0.9 app carries no equivalent, so this is now web-only.
// Capture-intention pipeline selector. Build-time override mirrors the app's
// --dart-define=INTENTION_MODE=…:
//   VITE_INTENTION_MODE=INTENT_VLM npx vite build
// Default matches the app default (INTENT_MLKIT_LABEL_RULES) so the playground
// is a faithful profiling proxy of the shipping camera flow.
//
//   INTENT_VLM                — cloud VLM brief (/v1/session/brief/stream):
//                               gpt-5.4-mini looks at the image → 3 intentions.
//   INTENT_MLKIT_LABEL_RULES  — on-device Image-Labeling option book on the app;
//                               the web has NO ML Kit, so it shows ALL options
//                               from the SINGLE SOURCE OF TRUTH:
//                               GET /api/v1/intention/rules?kind=INTENT_MLKIT_LABEL_RULES
//                               (admin-maintained via /update-mlkit-image-label).
//                               Title/summary stream from /brief/summary/stream
//                               (which also pre-binds the Managed Agent session).
export const INTENTION_MODE =
  (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_INTENTION_MODE) ||
  'INTENT_MLKIT_LABEL_RULES';

// True when the capture flow should present the admin option book instead of
// the cloud VLM's 3 generated intentions.
export const IS_LABEL_RULES = INTENTION_MODE === 'INTENT_MLKIT_LABEL_RULES';

// --- Shared Camera / Canvas Constants ---
export const CANVAS_WIDTH = 640;
export const CANVAS_HEIGHT = 480;
export const CANVAS_FPS = 5;
export const CAMERA_FPS = 15;
export const JPEG_QUALITY = 0.8;

// --- Animation ---
export const IOS_SPRING = { type: 'spring', stiffness: 340, damping: 32 };

// --- PiP (Picture-in-Picture) ---
export const PIP_SIZE = { width: 120, height: 160 };
export const PIP_EXPANDED_SIZE = { width: 240, height: 320 };
export const PIP_MARGIN = 16;
export const PIP_SPRING = { type: 'spring', stiffness: 300, damping: 30 };
